<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form>
      <div class="inner">
        <add-button v-if="$_createActionAllowed" :title="'Přidat operátora' | translate" route-name="operatorNew"></add-button>
        <h1 v-translate>Operátoři</h1>
      </div>
      <div class="inner_white">
        <div class="filter">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
          </div>
          <div class="field_right">
            <select-box
                id="operator_active"
                v-model="formFields.active"
                :options="operatorActiveOptions"
            >
              <translate class="translate">Stav operátora</translate>
            </select-box>
          </div>
          <div class="field_left">
            <select-box
                id="operator_category"
                v-model="formFields.category"
                :options="categoryOptions"
            >
              <translate class="translate">Kategorie operátora</translate>
            </select-box>
            </div>
          <div class="field_right" v-if="$_loggedUser_action_allowed('businessModels')">
            <select-box
                        id="businessmodel"
                        :options="businessModelOptions"
                        v-model="formFields.businessModel"
                        ref="businessmodelref"
            >
              <translate class="translate">Business model</translate>
            </select-box>
          </div>
          <multiselect-searchbox
              v-if="$_loggedUser_action_allowed('operatorTags')"
              :searchFunction="searchOperatorTags"
              v-model="formFields.operatorTagsIds"
          ><translate>Štítky operátora</translate></multiselect-searchbox>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>
        <form>
          <div class="scroll-wrapper">
            <div class="table_overflow" id="contentBox" data-table-id="operators-list">
              <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                <thead>
                <tr v-if="entities.length > 0">
                  <th class="no_padding drag_drop"></th>
                  <th class="no_padding checkbox"></th>
                  <sorting-table-title
                      v-for="title in sortingTableTitles"
                      :key="title.id"
                      :column="title.column"
                      :sort="getActiveSort(title.column)"
                      @changeSorting="changeSorting"
                  >{{ title.name }}
                  </sorting-table-title>
                  <th class="no_padding edit"></th>
                </tr>
                </thead>
                <tbody>
                <operator-row v-for="entity in entities"
                              :entity="entity"
                              :key="entity.id"
                              :selectedEntities="selectedEntities"
                              @input="select"
                              @updateEntity="updateEntity"
                ></operator-row>
                  <tr v-if="entities.length === 0">
                       <td colspan="8">{{ $gettext('Nebyli nalezeni žádní operátoři.') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <list-action-line
              :entities="entities"
              :selected-entities="filteredSelectedEntities"
              :multiple-action-options="multipleActionOptions"
              :offset="formFields.offset"
              :limit="formFields.limit"
              :total-count="totalCount"
              table-id="operators-list"
              @select-all="toggleSelectAll"
              @run-multiple-action="runMultipleAction"
              @limit="setLimit"
              @offset="setOffset"
              ref="action_line"
          ></list-action-line>
        </form>
      </div>
    </form>
  </div>
</template>

<script>
import OperatorRow from "@/components/views/operators/OperatorRow"
import AddButton from "@/components/common/AddButton"
import SortingTableTitle from "@/components/common/SortingTableTitle"
import Popup from "@/components/common/Popup"

import listActions from "@/components/mixins/list-actions"
import operators from "@/components/views/operators/mixins/operators"
import {prependOptions} from "@/utils/helpers"

export default {
  name: "OperatorList",
  components: {
    Popup,
    SortingTableTitle,
    AddButton,
    OperatorRow
  },
  mixins: [listActions, operators],
  data: function () {
    return {
      moduleName: 'operators',
      formFields: {
        active: 'all',
        category: 'all',
        businessModel: 0,
        operatorTagsIds: [],
      },
      operatorTags: [],
      businessModels: [],
    }
  },
  created(OperatorService, BusinessModelService, OperatorTagService) {
    this.entityService = OperatorService
    this.businessModelService = BusinessModelService
    this.operatorTagService = OperatorTagService

    if (this.$_readActionAllowedAllOrOwnAndGlobal) {
      this.businessModelService.getEntities()
          .then((data) => {
            this.businessModels = data['business_models']
          })
          .catch(error => {
            this.setErrorMessage(error['error_message'])
          })
    }

    this.createdInit()
  },
  computed: {
    multipleActionOptions() {
      let options = [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')}
      ];
      if(this.$_updateActionAllowed){
        options.push({value: 'activate', text: this.$gettext('Aktivovat')});
        options.push({value: 'deactivate', text: this.$gettext('Deaktivovat')});
      }

      return options;
    },
    sortingTableTitles() {
      return [
        {id: 1, name: this.$gettext('Název'), column: 'sName'},
        {id: 2, name: this.$gettext('Počet odběratelů'), column: 'sSubscribersCount'},
        {id: 3, name: this.$gettext('Počet zařízení'), column: 'sDevicesCount'},
        {id: 4, name: this.$gettext('Vloženo'), column: 'sDateCreated'},
        {id: 5, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ]
    },
    categoryOptions() {
      return [
        {id: 'all', text: this.$gettext('Všechny')},
        {id: 'testing', text: this.$gettext('Testovací')},
        {id: 'production', text: this.$gettext('Produkční')},
      ]
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles)
    },
    businessModelOptions() {
      if (this.businessModels) {
        return prependOptions(this._.map(this.businessModels, function (item) {
          return {id: item['id'], text: item['name']}
        }), this.$gettext('Všechny'))
      } else {
        return []
      }
    },
  },
  methods: {
    _afterDeleteActions() {
      this.reloadOperatorsSimpleList()
    },
    loadAdditionalDefaults() {
      let anyChanges = false
      if (this.loadDefaultByKey('active') && this.formFields.active !== 'all') {
        anyChanges = true
      }
      if (this.loadDefaultByKey('category') && this.formFields.category !== 'all') {
        anyChanges = true
      }
      if (this.loadDefaultByKey('businessModel')
          && this.formFields.businessModel !== 0
          && this.$_loggedUser_action_allowed('businessModels')
      ) {
        anyChanges = true
      }
      if (this.loadDefaultByKey('operatorTagsIds')
          && this.$_loggedUser_action_allowed('operatorTags')) {
        anyChanges = true;
      }
      return anyChanges
    },
    saveFilterValues() {
      this.saveSearch(this.formFields.search)
      this.setUserSetting('active', this.formFields.active)
      this.setUserSetting('category', this.formFields.category)
      this.setUserSetting('businessModel', this.formFields.businessModel)
      this.setUserSetting('operatorTagsIds', this.formFields.operatorTagsIds)
    },
    searchOperatorTags(search, selectAll = false){
      return this.operatorTagService.searchTagsByName({name_search: search, select_all: selectAll})
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/operators/OperatorList.vue